var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-data-card",class:{'mobile': _vm.isMobileDevice}},[_c('div',{staticClass:"card-name"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('span',{staticClass:"card-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]),_c('span',{staticClass:"card-unit"},[_vm._v("\n    "+_vm._s(_vm.unit)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }